import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { SpaView } from "./views/spa/spa";
import { Preloader } from "./components/preloader/preloader";
import './App.css';

function LocalizedRoutes() {
  const { lang } = useParams<{ lang: string }>();
  if (!lang) return <Navigate to="/en" replace />;

  return (
    <Routes>
      <Route index element={<SpaView lang={lang} />} />
      <Route path="*" element={<Navigate to={`/${lang}`} replace />} />
    </Routes>
  );
}

export default function App() {
  // Inicialización perezosa para decidir si mostrar preloader
  const [showPreloader] = useState<boolean>(() => {
    const last = localStorage.getItem("lastVisit");
    if (!last) return true;
    const twelveH = 12 * 60 * 60 * 1000;
    return Date.now() - parseInt(last) > twelveH;
  });
  const [lang, setLang] = useState<string | null>(null);
  const [preFade, setPreFade] = useState(false);
  const [fadeIn, setFadeIn] = useState(false);
  const [showApp, setShowApp] = useState(false);

  useEffect(() => {
    let done = false;

    const detectAndLoad = () => {
      if (done) return;
      done = true;

      const navLang = navigator.language.slice(0, 2);
      setLang(navLang === "es" ? "es" : "en");

      if (showPreloader) {
        setPreFade(true);
        setTimeout(() => {
          setShowApp(true);
          requestAnimationFrame(() => setFadeIn(true));
        }, 500);
      } else {
        setShowApp(true);
        requestAnimationFrame(() => setFadeIn(true));
      }
    };

    const onLoad = () => detectAndLoad();
    if (document.readyState === "complete") {
      detectAndLoad();
    } else {
      window.addEventListener("load", onLoad);
      return () => window.removeEventListener("load", onLoad);
    }
  }, [showPreloader]);

  // Guardamos timestamp una vez que la app se monta
  useEffect(() => {
    if (showApp) {
      localStorage.setItem("lastVisit", Date.now().toString());
    }
  }, [showApp]);

  return (
    <>
      {showPreloader && !showApp && <Preloader fadeOut={preFade} />}

      {showApp && (
        <div className={`app-root ${fadeIn ? "fade-in" : ""}`}>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Navigate to={`/${lang}`} replace />} />
              <Route path="/:lang/*" element={<LocalizedRoutes />} />
            </Routes>
          </BrowserRouter>
        </div>
      )}
    </>
  );
}
